import styled from 'styled-components';

export const StyledSeparator = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${props => props.color};
`;